import type { GrupoCajaChica } from '../services/tesoreriaService';
import { readTabSession } from './sessionAuthStore';

const GRUPO_CAJA_KEY = 'grupoCajaChicaSeleccionado';
const GRUPO_CAJA_MCP_KEY = 'grupoCajaMcp';

/**
 * Las claves se separan por tenant: los grupos de caja (GrupoMCP) son propios de cada base
 * y localStorage es compartido entre pestañas que pueden estar en tenants distintos.
 */
const sufijoTenant = (): string => {
    const tenantId = readTabSession().tenantId;
    return tenantId != null ? `:${tenantId}` : '';
};

export const grupoCajaStorageKey = (): string => `${GRUPO_CAJA_KEY}${sufijoTenant()}`;
export const grupoCajaMcpStorageKey = (): string => `${GRUPO_CAJA_MCP_KEY}${sufijoTenant()}`;

/** JSON del grupo de caja guardado para el tenant actual (o null). */
export function leerGrupoCajaGuardadoRaw(): string | null {
    try {
        return localStorage.getItem(grupoCajaStorageKey());
    } catch {
        return null;
    }
}

/** Código GrupoMCP guardado para el tenant actual (o null). */
export function leerGrupoCajaMcpGuardado(): string | null {
    try {
        return localStorage.getItem(grupoCajaMcpStorageKey());
    } catch {
        return null;
    }
}

export function persistGrupoCajaChica(grupo: GrupoCajaChica): void {
    try {
        localStorage.setItem(grupoCajaStorageKey(), JSON.stringify(grupo));
        localStorage.setItem(grupoCajaMcpStorageKey(), String(grupo.codigo ?? ''));
    } catch {
        /* ignore */
    }
}

/** Borra el grupo de caja guardado de todos los tenants (logout / sesión vencida). */
export function clearGrupoCajaStorage(): void {
    try {
        const claves: string[] = [];
        for (let i = 0; i < localStorage.length; i++) {
            const k = localStorage.key(i);
            if (k && (k.startsWith(GRUPO_CAJA_KEY) || k.startsWith(GRUPO_CAJA_MCP_KEY))) claves.push(k);
        }
        claves.forEach((k) => localStorage.removeItem(k));
    } catch {
        /* ignore */
    }
}

export function findGrupoCajaGuardado(grupos: GrupoCajaChica[]): GrupoCajaChica | null {
    const saved = leerGrupoCajaGuardadoRaw();
    if (!saved) return null;
    try {
        const parsed = JSON.parse(saved);
        const savedId = parsed?.id ?? null;
        if (savedId != null) {
            const byId = grupos.find((g) => g.id === savedId);
            if (byId) return byId;
        }
        const codigo = Number(parsed?.codigo ?? null);
        if (Number.isFinite(codigo) && codigo > 0) {
            return grupos.find((g) => g.codigo === codigo) ?? null;
        }
    } catch {
        /* ignore */
    }
    return null;
}
